import { Grid, Paper, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { t } from "i18next";

import "../stylesheets/pages/wait.scss";

export default function Wait() {
  return (
    <Box className="wait-container">
      <Paper elevation={0} className="paper-container">
        <Grid
          container
          justifyContent={"center"}
          alignItems={"center"}
          padding={4}
        >
          <Typography variant="h6" fontWeight={"bold"} color={"secondary"}>
            {t("wait.title")}
          </Typography>
          <Typography marginTop={2} variant="subtitle2" fontWeight={"400"}>
            {t("wait.subTitle")}
          </Typography>
        </Grid>
      </Paper>
      <Typography variant="caption" marginTop={5}>
        {t("wait.waitEstimate")}
      </Typography>
    </Box>
  );
}
